module.exports = __webpack_public_path__ + "img/accordion-mask-string-ties-default.c3f77848.jpg";